import type moment from 'moment-timezone';

export type TimeSpan = {
  start: moment.Moment;
  end: moment.Moment;
  days: number;
  weeks: number;
  months: number;
  quarters: number;
  years: number;
};

export type TimeSpanValue = Omit<TimeSpan, 'start' | 'end'>;

export const timeSpan = (start: moment.Moment, end: moment.Moment): TimeSpan => ({
  start,
  end,
  days: end.diff(start, 'days'),
  weeks: end.diff(start, 'weeks'),
  months: end.diff(start, 'months'),
  quarters: end.diff(start, 'quarters'),
  years: end.diff(start, 'years'),
});
